import { getGatewaysV2 } from 'redux/rootSelectors';
import { createSelector } from 'reselect';

/**
 * Memoized selector for `gatewayVersionsByGtwId` to prevent unnecessary recomputation.
 */
export const selectGatewayVersionsByGtwId = createSelector([getGatewaysV2], state => state.gatewayVersionsByGtwId);
